import { Gavel, Scale, Shield, Building2, Lightbulb, Info } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { authorityConfig, type AuthorityLevel } from "@iamu/shared";

interface AuthorityStyle {
  label: string;
  bg: string;
  text: string;
  border: string;
  /** Decorative level dot (aria-hidden next to the label) */
  dot: string;
  icon: LucideIcon;
}

// Text and surfaces are neutral tokens (AAA in both themes); only the
// decorative dot carries the level's hue.
const levelStyle: Record<AuthorityLevel, { dot: string; icon: LucideIcon }> = {
  legislation: { dot: "bg-purple-500", icon: Gavel },
  regulation: { dot: "bg-blue-500", icon: Scale },
  standard: { dot: "bg-teal-500", icon: Shield },
  company_policy: { dot: "bg-amber-500", icon: Building2 },
  guideline: { dot: "bg-gray-500", icon: Lightbulb },
  informational: { dot: "bg-slate-400", icon: Info },
};

export function getAuthorityStyle(level: string): AuthorityStyle {
  const key = (level in levelStyle ? level : "informational") as AuthorityLevel;
  return {
    label: authorityConfig[key].label,
    bg: "bg-muted",
    text: "text-foreground",
    border: "border-border",
    ...levelStyle[key],
  };
}
